import React, { useId } from "react";

export const BellIcon = ({
	size = 18,
	className = "",
	title = "Notifications",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
		<path d="M13.73 21a2 2 0 0 1-3.46 0" />
	</svg>
);

export const GoLiveSuccessSVG = () => (
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none">
		<circle
			cx="40"
			cy="40"
			r="38"
			fill="#f0fdf4"
			stroke="#86efac"
			strokeWidth="2"
		/>
		<circle cx="40" cy="40" r="28" fill="#dcfce7" />
		<path
			className="ag-success-check"
			d="M26 40.5L35 50L54 28"
			stroke="#16a34a"
			strokeWidth="4"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeDasharray="44"
			strokeDashoffset="44"
		/>
	</svg>
);

export const GoLiveErrorSVG = () => (
	<svg width="52" height="52" viewBox="0 0 52 52" fill="none">
		<circle
			cx="26"
			cy="26"
			r="24"
			fill="#fee2e2"
			stroke="#fca5a5"
			strokeWidth="2"
		/>
		<path
			d="M18 18L34 34M34 18L18 34"
			stroke="#ef4444"
			strokeWidth="3"
			strokeLinecap="round"
		/>
	</svg>
);

export const PaperclipIcon = ({
	size = 16,
	className = "",
	title = "Attachment",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		width={size}
		height={size}
		fill="currentColor"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M256,0c-54.013,0-97.955,43.943-97.955,97.955v338.981c0,41.39,33.674,75.064,75.064,75.064
			c41.39,0,75.064-33.674,75.064-75.064V122.511c0-28.327-23.046-51.375-51.375-51.375c-28.327,0-51.374,23.047-51.374,51.375
			v296.911h31.347V122.511c0-11.042,8.984-20.028,20.028-20.028s20.028,8.985,20.028,20.028v314.424
			c0,24.106-19.612,43.717-43.718,43.717c-24.106,0-43.717-19.612-43.717-43.717V97.955c0-36.727,29.88-66.608,66.608-66.608
			s66.608,29.881,66.608,66.608v321.467h31.347V97.955C353.955,43.943,310.013,0,256,0z" />
	</svg>
);

// ── Side Nav Icons (uncolored — inherit color via currentColor) ───────────────

export const DashboardIcon = ({ size = 20, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<rect x="3" y="3" width="7" height="7" rx="1" />
		<rect x="14" y="3" width="7" height="7" rx="1" />
		<rect x="3" y="14" width="7" height="7" rx="1" />
		<rect x="14" y="14" width="7" height="7" rx="1" />
	</svg>
);

export const ReservationsIcon = ({ size = 20, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
		<path d="M16 3v4M8 3v4M3 10h18" />
		<path d="M8 14l2.5 2.5L16 10" />
	</svg>
);

export const CalendarIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<rect x="3" y="4" width="18" height="18" rx="2" />
		<path d="M16 2v4M8 2v4M3 10h18" />
		<circle cx="8" cy="16" r="1" fill={color} stroke="none" />
		<circle cx="12" cy="16" r="1" fill={color} stroke="none" />
		<circle cx="16" cy="16" r="1" fill={color} stroke="none" />
	</svg>
);

export const CleaningIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		{/* broom handle */}
		<line x1="19" y1="3" x2="9" y2="13" />
		{/* broom head base */}
		<path d="M5 17c0-2.2 1.8-4 4-4h6l1 4H5z" />
		{/* bristles */}
		<path d="M5 17l-1 4" />
		<path d="M8 17l-.5 4" />
		<path d="M11 17l0 4" />
		<path d="M14 17l.5 4" />
		<path d="M16 21l.5-4" />
	</svg>
);

export const HouseIcon = ({ size = 20, className = "", ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		{...rest}>
		<path d="M3 12L12 3l9 9" />
		<path d="M9 21V12h6v9" />
		<path d="M5 21h14" />
	</svg>
);

export const CollectionsIcon = ({ size = 20, color = "currentColor", ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<rect x="2" y="7" width="20" height="15" rx="2" />
		<path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
		<path d="M7 12h10M7 16h6" />
	</svg>
);

export const WebsiteIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<circle cx="12" cy="12" r="9" />
		<path d="M12 3c-2.5 3-4 5.5-4 9s1.5 6 4 9" />
		<path d="M12 3c2.5 3 4 5.5 4 9s-1.5 6-4 9" />
		<path d="M3 12h18" />
	</svg>
);

export const TaxIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<rect x="4" y="2" width="16" height="20" rx="2" />
		<path d="M8 10h8M8 14h4" />
		<path d="M14 17l4-4" />
		<circle cx="15" cy="14" r="0.8" fill="currentColor" stroke="none" />
		<circle cx="17" cy="16" r="0.8" fill="currentColor" stroke="none" />
	</svg>
);

export const OrganizationIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<rect x="3" y="4" width="18" height="17" rx="1" />
		<path d="M3 9h18" />
		<path d="M9 9v12M15 9v12" />
	</svg>
);

export const ProfileIcon = ({
	size = 20,
	className = "",
	title = "Profile",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="12" cy="8" r="4" />
		<path d="M4 20v-1a8 8 0 0 1 16 0v1" />
	</svg>
);

export const UsersIcon = ({ size = 20, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<circle cx="9" cy="8" r="3" />
		<path d="M3 21v-1a6 6 0 0 1 6-6v0a6 6 0 0 1 6 6v1" />
		<path d="M16 5a3 3 0 0 1 0 6" />
		<path d="M21 21v-1a6 6 0 0 0-4-5.66" />
	</svg>
);

export const PromotionsIcon = ({ size = 20, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<polygon points="12,1 15.1,4.6 19.8,4.2 19.4,8.9 23,12 19.4,15.1 19.8,19.8 15.1,19.4 12,23 8.9,19.4 4.2,19.8 4.6,15.1 1,12 4.6,8.9 4.2,4.2 8.9,4.6" />
		<line x1="9" y1="15" x2="15" y2="9" />
		<circle cx="9" cy="9" r="1.5" />
		<circle cx="15" cy="15" r="1.5" />
	</svg>
);

export const AiChatIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
		<path
			d="M9 10h.01M12 10h.01M15 10h.01"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
	</svg>
);

export const HeadSetIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M3 18v-6a9 9 0 0 1 18 0v6" />
		<rect x="3" y="16" width="4" height="6" rx="1" />
		<rect x="17" y="16" width="4" height="6" rx="1" />
	</svg>
);

export const ValidationIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<path d="M12 2l8 3v7c0 4.5-3.5 8.5-8 10-4.5-1.5-8-5.5-8-10V5l8-3z" />
		<path d="M9.5 9.5l5 5M14.5 9.5l-5 5" />
	</svg>
);

// Small warning triangle for use as a tab indicator (accepts size prop)
export const TabWarningIcon = ({ size = 13, className = "", ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="currentColor"
		aria-hidden="true"
		className={className}
		{...rest}>
		<path d="M8 1.5a.75.75 0 0 1 .65.376l6.25 10.5A.75.75 0 0 1 14.25 13.5H1.75a.75.75 0 0 1-.65-1.124l6.25-10.5A.75.75 0 0 1 8 1.5ZM8 6a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 6Zm0 6a.875.875 0 1 0 0-1.75A.875.875 0 0 0 8 12Z" />
	</svg>
);

export const SpreadsheetIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<rect x="3" y="3" width="18" height="18" rx="1" />
		<path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
	</svg>
);

export const ChartIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M18 20V10M12 20V4M6 20v-6" />
		<path d="M3 20h18" />
	</svg>
);

export const PercentIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<circle cx="7.5" cy="7.5" r="3" />
		<circle cx="16.5" cy="16.5" r="3" />
		<path d="M4 20L20 4" />
	</svg>
);

export const CreditCardIcon = ({ size = 20, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...rest}>
		<rect x="2" y="5" width="20" height="14" rx="2" />
		<path d="M2 10h20" />
		<path d="M6 15h4" />
	</svg>
);

export const FaqIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<circle cx="12" cy="12" r="9" />
		<path d="M9.5 9a2.5 2.5 0 0 1 4.9.6c0 1.7-2.4 2.4-2.4 4" />
		<circle cx="12" cy="17" r="0.8" fill="currentColor" stroke="none" />
	</svg>
);

export const ReportsIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<path d="M14 2v6h6" />
		<path d="M8 13h8M8 17h4" />
	</svg>
);

export const SettingsIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<circle cx="12" cy="12" r="3" />
		<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
	</svg>
);

export const LogoutIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
		<polyline points="16 17 21 12 16 7" />
		<line x1="21" y1="12" x2="9" y2="12" />
	</svg>
);
// Simple Switch Arrows Icon
export const SwitchArrowsIcon = ({
	size = 20,
	className = "",
	title = "Switch",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		className={className}
		{...rest}>
		<path d="M4 9h16" />
		<path d="M16 5l4 4-4 4" />
		<path d="M20 15H4" />
		<path d="M8 19l-4-4 4-4" />
	</svg>
);

export const HamburgerIcon = ({
	size = 22,
	className = "",
	title = "Menu",
	weight = 2.5,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={`hamburger-icon-svg ${className}`}
		{...rest}>
		<title>{title}</title>
		<line x1="3" y1="6" x2="21" y2="6" />
		<line x1="3" y1="12" x2="21" y2="12" />
		<line x1="3" y1="18" x2="21" y2="18" />
	</svg>
);

// Simple Chevron Up Icon
// Simple Chevron Down Icon
export const ChevronDownIcon = ({
	size = 14,
	className = "",
	title = "Collapse",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={`chevron-down-svg ${className}`}
		{...rest}>
		<title>{title}</title>
		<path d="M3 6l5 5 5-5" />
	</svg>
);

// Status: Success (green circle with check)
export const StatusSuccessIcon = ({
	size = 16,
	className = "",
	title = "Success",
	color = "#28a745",
	fg = "#ffffff",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={`status-success-svg ${className}`}
		{...rest}>
		<title>{title}</title>
		<circle cx="8" cy="8" r="7" fill={color} />
		<path
			d="M5 8.5 L7 10.5 L11 6.5"
			fill="none"
			stroke={fg}
			strokeWidth={weight}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

// Status: Warning (yellow triangle with exclamation)
export const StatusWarningIcon = ({
	size = 16,
	className = "",
	title = "Warning",
	color = "#ffc107",
	fg = "#212529",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={`status-warning-svg ${className}`}
		{...rest}>
		<title>{title}</title>
		<path d="M8 1.5 L15 14.5 H1 Z" fill={color} />
		<line
			x1="8"
			y1="6"
			x2="8"
			y2="10"
			stroke={fg}
			strokeWidth={weight}
			strokeLinecap="round"
		/>
		<circle cx="8" cy="12.25" r="1" fill={fg} />
	</svg>
);

export const DownloadCsvIcon = ({
	size = 16,
	className = "",
	color = "currentColor",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke={color}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		focusable="false"
		className={className}
		{...rest}>
		<path d="M12 3v12" />
		<path d="M7 11l5 5 5-5" />
		<path d="M3 17v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2" />
	</svg>
);

// Status: Error/Danger (red circle with exclamation)
export const StatusErrorIcon = ({
	size = 16,
	className = "",
	title = "Error",
	color = "#dc3545",
	fg = "#ffffff",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={`status-error-svg ${className}`}
		{...rest}>
		<title>{title}</title>
		<circle cx="8" cy="8" r="7" fill={color} />
		<line
			x1="8"
			y1="4.5"
			x2="8"
			y2="9.5"
			stroke={fg}
			strokeWidth={weight}
			strokeLinecap="round"
		/>
		<circle cx="8" cy="12" r="1.1" fill={fg} />
	</svg>
);
/**
 * SupportTicketSVG — a ticket/tag shape with a punch hole, representing a support ticket.
 *
 * Props:
 *   size      – number (default 24)
 *   color     – fill color (default "currentColor")
 *   className – extra class on the svg
 */
export const SupportTicketSVG = ({
	size = 24,
	color = "currentColor",
	className = "",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		aria-label="Support Ticket"
		role="img"
		focusable="false"
		className={className || undefined}
		{...rest}>
		{/* ticket body */}
		<path
			d="M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7Z"
			fill={color}
			fillOpacity="0.12"
			stroke={color}
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
		{/* perforation line */}
		<line
			x1="8"
			y1="5"
			x2="8"
			y2="19"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeDasharray="2 2"
		/>
		{/* text lines on the stub */}
		<line x1="11" y1="9" x2="19" y2="9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
		<line x1="11" y1="12" x2="17" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
		<line x1="11" y1="15" x2="19" y2="15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export const ChevronLeftIcon = ({ size = 16 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		strokeLinecap="round"
		strokeLinejoin="round">
		<polyline points="15 18 9 12 15 6" />
	</svg>
);

export const ChevronRightIcon = ({ size = 16 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		strokeLinecap="round"
		strokeLinejoin="round">
		<polyline points="9 18 15 12 9 6" />
	</svg>
);

export const ArrowRightIcon = ({ size = 11 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		strokeLinecap="round"
		strokeLinejoin="round">
		<path d="M5 12h14M12 5l7 7-7 7" />
	</svg>
);

export const StepDoneIcon = ({ className = "" }) => (
	<svg
		className={className}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none">
		<circle cx="10" cy="10" r="10" fill="#10b981" />
		<path
			d="M6 10.5L9 13.5L14 7"
			stroke="white"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeDasharray="20"
			strokeDashoffset="0"
		/>
	</svg>
);

export const StepActiveIcon = ({ className = "" }) => (
	<svg
		className={className}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none">
		<circle cx="10" cy="10" r="8" stroke="#f5c0c4" strokeWidth="2.5" />
		<path
			d="M10 2 A8 8 0 0 1 18 10"
			stroke="#ac2431"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
	</svg>
);

export const StepPendingIcon = ({ className = "" }) => (
	<svg
		className={className}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none">
		<circle cx="10" cy="10" r="5" fill="#d1d5db" />
	</svg>
);

/**
 * WifiIcon — renders 4 arcs with the bottom dot; inactive arcs are dimmed.
 * bars: 0–4  (how many arcs are "active")
 * size: icon dimensions in px
 * color: active arc color (defaults to currentColor)
 */
export const WifiIcon = ({ bars = 4, size = 24, color = "currentColor", ...rest }) => {
	const dim = "#d0d0d0";
	// arc paths drawn from bottom-center outward, radii 3 / 6 / 10 / 14
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			{...rest}>
			{/* dot */}
			<circle cx="12" cy="20" r="1.2" fill={color} stroke="none" />
			{/* arc 1 — smallest */}
			<path
				d="M9.2 17.2 A4 4 0 0 1 14.8 17.2"
				stroke={bars >= 1 ? color : dim}
			/>
			{/* arc 2 */}
			<path
				d="M6.3 14.3 A8 8 0 0 1 17.7 14.3"
				stroke={bars >= 2 ? color : dim}
			/>
			{/* arc 3 */}
			<path
				d="M3.4 11.4 A12 12 0 0 1 20.6 11.4"
				stroke={bars >= 3 ? color : dim}
			/>
			{/* arc 4 — largest */}
			<path
				d="M0.6 8.6 A16 16 0 0 1 23.4 8.6"
				stroke={bars >= 4 ? color : dim}
			/>
		</svg>
	);
}

/**
 * BatteryIcon — classic horizontal battery outline with a fill bar.
 * level: 0–1 (fraction full)
 * size: icon dimensions in px
 * The fill color shifts: green ≥50%, amber 20-49%, red <20%
 */
export const BatteryIcon = ({ level = 1, size = 18 }) => {
	const pct = Math.max(0, Math.min(1, level ?? 0));
	const fillColor = pct >= 0.5 ? "#1a7a45" : pct >= 0.2 ? "#e6a817" : "#ac2431";
	// Square 24x24 viewBox — body centered vertically: y=6 h=12
	const fillWidth = Math.round(15 * pct);
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			{/* body outline */}
			<rect x="1" y="6" width="19" height="12" rx="2"
				stroke="#555" strokeWidth="1.5" fill="none" />
			{/* nub */}
			<rect x="20" y="9" width="3" height="6" rx="1"
				fill="#555" />
			{/* fill */}
			{fillWidth > 0 && (
				<rect x="3" y="8" width={fillWidth} height="8" rx="1"
					fill={fillColor} />
			)}
		</svg>
	);
}

export const LockIcon = ({ size = 16, color = '#1a7a45', ...rest }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
		<rect x="5" y="11" width="14" height="10" rx="2" fill={color} />
		<path d="M8 11V7a4 4 0 0 1 8 0v4" stroke={color} strokeWidth="2" strokeLinecap="round" />
		<circle cx="12" cy="16" r="1.5" fill="#fff" />
	</svg>
);

export const UnlockIcon = ({ size = 16, color = '#ac2431' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="5" y="11" width="14" height="10" rx="2" fill={color} />
		<path d="M8 11V7a4 4 0 0 1 8 0" stroke={color} strokeWidth="2" strokeLinecap="round" />
		<line x1="16" y1="7" x2="19" y2="7" stroke={color} strokeWidth="2" strokeLinecap="round" />
		<circle cx="12" cy="16" r="1.5" fill="#fff" />
	</svg>
);

export const LockUnknownIcon = ({ size = 16, color = '#888' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="5" y="11" width="14" height="10" rx="2" fill={color} />
		<path d="M8 11V7a4 4 0 0 1 8 0v4" stroke={color} strokeWidth="2" strokeLinecap="round" />
		<text x="12" y="19" textAnchor="middle" fontSize="7" fontWeight="bold" fill="#fff">?</text>
	</svg>
);

// ── Channel Brand Badges ─────────────────────────────────────────────────────

export const BookingComBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 73.927 72.408"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="Booking.com"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<rect width="73.927" height="72.408" rx="10" fill="#003580" />
		<g transform="translate(36.964,36.204) scale(0.72) translate(-36.964,-36.204)">
			<g transform="translate(45.311933,-49.834307)">
				<g transform="matrix(1.378728,0,0,1.378728,-79.238333,13.337998)">
					<path
						fill="#ffffff"
						d="m 35.940796,56.048166 c -1.072151,0.679833 -1.250696,2.041807 -1.279101,3.205255 -0.0086,3.395701 0.0041,6.791402 0.0041,10.183639 3.130416,-0.01731 6.265265,0.02424 9.400112,-0.008 2.141185,-0.04271 4.327383,-1.180761 5.337783,-3.115226 1.523909,-2.92709 1.225892,-7.0511 -1.37871,-9.279888 -2.133105,-1.789034 -5.077277,-1.565117 -7.677838,-1.581275 -1.465737,0.06117 -3.101491,-0.244694 -4.406296,0.595575 z M 35.646829,35.880568 c -0.877826,0.775632 -0.952227,2.017568 -0.985134,3.107147 -0.0086,2.798972 0.0082,5.59448 0,8.393451 2.724606,-0.01267 5.449591,0.03694 8.174693,-0.01267 1.631136,-0.03232 3.275085,-0.744469 4.27325,-2.061429 1.967129,-2.683549 1.855285,-7.1065 -0.948187,-9.177163 -1.921538,-1.403525 -4.414873,-1.011092 -6.642623,-1.072266 -1.300223,0.03232 -2.852989,-0.174285 -3.871999,0.822956 z M 24.615514,31.9597 c -0.178543,-2.923627 2.488324,-5.562162 5.386938,-5.487138 4.418936,0 8.837466,-0.0035 13.255917,0 4.352661,0.09926 8.956823,1.379287 12.033614,4.61686 4.746248,4.895025 4.46035,13.600115 -0.430637,18.295461 -0.575261,0.539019 -1.183994,1.031868 -1.780493,1.540877 2.518152,1.262711 4.849551,3.088679 6.103837,5.672967 2.273687,4.642253 2.000022,10.559913 -0.894056,14.875523 -3.184479,4.728819 -9.102024,6.732535 -14.593202,6.857191 -6.356723,0.02078 -12.717509,0 -19.077861,0.008 -0.0041,-15.458401 0.0041,-30.916803 -0.0041,-46.37982 v 0"
					/>
					<path
						fill="#52aee5"
						d="m 70.25713,66.571145 c 3.623079,-1.118434 7.739014,1.755561 7.934065,5.541385 0.376285,3.328756 -2.30612,6.609036 -5.661419,6.8318 -3.307979,0.422442 -6.591728,-2.214939 -6.877971,-5.53677 -0.435138,-3.018273 1.635526,-6.111569 4.605325,-6.836415 v 0"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const AirbnbBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 512 512"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="Airbnb"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<rect width="512" height="512" rx="15%" fill="#FF5A5F" />
		<path
			fill="none"
			stroke="#fff"
			strokeWidth="23"
			strokeLinejoin="round"
			d="m255 83.7c-29 .1-40.6 23.9-40.6 23.9-36.2 66.5-70 134.2-101.2 203.2-17.2 38-4.6 68.2 14.8 84.5 36.8 31 82 13.4 126.5-38.7 34.3-40 49.8-73.2 48.3-100.6-1.3-23.9-15.8-43.7-47.9-43.7-47.3-.2-48.3 44.6-48.5 43.7 0 46.6 42.8 93.5 56 108.6 13.3 15.1 70.8 73.4 121.5 30 37.7-32.1 13.1-83.8 13.1-83.8-30.6-67.6-51-111.5-99.9-203.2 0 0-10.6-24-42.2-24v.1z"
		/>
	</svg>
);

export const ExpediaBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 600 600"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="Expedia"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<rect width="600" height="600" rx="90" fill="#FFC72C" />
		<g transform="translate(0,600) scale(0.05,-0.05)" fill="#00355F" stroke="none">
			<path d="M3190 9811 c-122 -55 -1297 -1260 -1297 -1330 0 -128 -181 -120 2697 -120 l2620 -1 -1623 -1625 c-893 -894 -1633 -1645 -1645 -1669 -14 -28 -22 -221 -22 -551 0 -663 -71 -595 621 -595 l528 0 1646 1645 1645 1645 0 -2616 0 -2616 49 -49 c27 -27 65 -49 84 -49 59 0 1304 1257 1329 1340 13 46 18 1076 14 3060 l-6 2990 -54 114 c-75 161 -216 304 -374 382 l-132 64 -3010 4 c-2514 4 -3020 0 -3070 -23z" />
			<path d="M2217 3622 l-47 -38 -6 -653 -6 -652 60 -60 59 -59 640 0 641 0 56 48 56 48 6 597 c7 645 2 709 -57 768 -60 60 -1328 60 -1402 1z" />
		</g>
	</svg>
);

export const VrboBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="VRBO"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<path d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z" fill="#1660CF" />
		<g fill="#ffffff">
			<path d="m14.76 10.79.04.02c.96-3.17 1.27-4.57.42-5.42h-1.2v.03c1.34.47 1.64 1.83.74 5.37Z" />
			<path fillRule="evenodd" clipRule="evenodd" d="M18.57 5.39c-1.28.74-2.04 2.12-3.65 5.5l.04.03c1.85-3.43 2.9-4.8 5.28-5.5v-.03h-1.67Z" />
			<path d="m14.84 10.84.04.03c1.51-3.56 1.91-4.53 2.53-5.45v-.03h-1.23v.04c.13 1.41-.36 2.72-1.34 5.41Z" />
			<path fillRule="evenodd" clipRule="evenodd" d="M4.75 5.39H3.66v.03c1 .38 1.48 1.13 1.87 2.88L8.2 20.55h.61L6.12 8.2C5.66 6.1 5.17 5.7 4.75 5.4Z" />
			<path fillRule="evenodd" clipRule="evenodd" d="m10.44 19.7.4-.84L8.58 8.29c-.4-1.64-.3-2.39-.14-2.9h-.87a9.4 9.4 0 0 0 .34 2.63l2.53 11.67Z" />
			<path d="M6.78 5.39H5.76v.03c.46.54.59 1.2.95 2.67l2.71 12.46h.61L7.31 8.05c-.38-1.6-.45-2.04-.53-2.66Z" />
			<path d="m11.25 18.01.4-.84-1.8-8.69c-.35-1.69-.2-2.56.36-3.06v-.03h-.96c-.3.63-.4 1.26-.05 2.93l2.05 9.7Z" />
			<path d="M10.49 8.54c-.5-2.33.38-2.95.8-3.15h1.43v.03c-1.55.3-2 1.15-1.63 3.1l1.38 6.96-.4.85-1.58-7.8Z" />
		</g>
	</svg>
);

export const TripAdvisorBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 63.997 64"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="TripAdvisor"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<rect width="63.997" height="64" rx="10" fill="#d4f2e7" />
		<g transform="matrix(.568111 0 0 .568111 -18.190262 12.840025)">
			<path d="M88.28 0C73.612 0 60.36 3.694 49.91 10.523l-17.58.016s4.148 5.537 5.494 11.12L82.318 55.8l5.972 8.928 6.03-9.004 44.596-34.088c1.324-5.62 5.52-11.23 5.52-11.23l-18.734-.013C115.194 3.603 102.424 0 88.278 0z" fill="#000a12" />
			<path d="M115.484 10.318a28.015 28.015 0 0 0-8.839 1.695 27.91 27.91 0 0 0-15.777 14.603c-1.418 3.075-2.22 6.326-2.475 9.597C87.35 21.873 75.515 10.497 60.98 10.2c8.04-3.44 17.278-5.3 27.29-5.3 10.08 0 19.18 1.817 27.213 5.418" fill="#fcc40f" />
			<g stroke="#000a12">
				<circle r="25.132" cy="39.396" cx="60.072" fill="#fff" strokeWidth="5.847" />
				<circle r="11.3" cy="39.396" cx="60.072" fill="none" strokeWidth="5.102" />
			</g>
			<circle r="4.667" cy="39.396" cx="60.072" fill="#ef6a45" />
			<g stroke="#000a12">
				<circle r="25.132" cy="39.346" cx="116.615" fill="#fff" strokeWidth="5.847" />
				<circle r="11.3" cy="39.346" cx="116.615" fill="none" strokeWidth="5.102" />
			</g>
			<circle r="4.667" cy="39.346" cx="116.615" fill="#00b087" />
		</g>
	</svg>
);

export const RedAwningBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 200 220"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="RedAwning"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<title>RedAwning</title>
		<rect width="200" height="220" rx="20" fill="#ffffff" />
		<g transform="translate(100,110) scale(1.25) translate(-68,-116.5)">
			{/* Door body */}
			<rect x="34" y="89" width="68" height="108" rx="3" fill="#a8d8ea" stroke="#2a2a2a" strokeWidth="3" strokeLinejoin="round" />
			{/* Door top panel */}
			<rect x="42" y="97" width="52" height="42" rx="2" fill="#c5e8f5" stroke="#2a2a2a" strokeWidth="2.5" />
			{/* Door bottom panel */}
			<rect x="42" y="147" width="52" height="44" rx="2" fill="#c5e8f5" stroke="#2a2a2a" strokeWidth="2.5" />
			{/* Doorknob */}
			<circle cx="50" cy="159" r="4" fill="white" stroke="#2a2a2a" strokeWidth="2" />
			{/* Awning dome */}
			<path d="M14,88 Q16,40 68,36 Q120,40 122,88 Z" fill="#CC2222" stroke="#2a2a2a" strokeWidth="3" strokeLinejoin="round" />
			{/* Awning ribs */}
			<path d="M30,87 Q36,50 55,40" fill="none" stroke="#8B0000" strokeWidth="2.5" strokeLinecap="round" />
			<path d="M50,87 Q56,42 68,38" fill="none" stroke="#8B0000" strokeWidth="2.5" strokeLinecap="round" />
			<path d="M86,87 Q80,42 68,38" fill="none" stroke="#8B0000" strokeWidth="2.5" strokeLinecap="round" />
			<path d="M106,87 Q100,50 81,40" fill="none" stroke="#8B0000" strokeWidth="2.5" strokeLinecap="round" />
			{/* Wavy valance */}
			<path
				d="M14,88 L122,88 L122,92 Q117.5,104 113,92 Q108.5,80 104,92 Q99.5,104 95,92 Q90.5,80 86,92 Q81.5,104 77,92 Q72.5,80 68,92 Q63.5,104 59,92 Q54.5,80 50,92 Q45.5,104 41,92 Q36.5,80 32,92 Q27.5,104 23,92 Q18.5,80 14,92 Z"
				fill="white"
				stroke="#2a2a2a"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);

export const HmviBadge = ({ size = 22 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 468 600"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="HMVI Marriott"
		style={{ display: 'block', flexShrink: 0 }}
	>
		<rect width="468" height="600" rx="40" fill="#F4845F" />
		<g transform="translate(0,600) scale(0.1,-0.1)" fill="#ffffff" stroke="none">
			<path d="M0 3000 l0 -3000 2340 0 2340 0 0 3000 0 3000 -2340 0 -2340 0 0 -3000z m927 2660 c32 -50 362 -573 733 -1164 371 -590 677 -1072 680 -1070 3 1 334 525 735 1163 l730 1160 263 1 c144 0 262 -2 262 -5 0 -3 -20 -36 -44 -73 -24 -37 -109 -170 -188 -297 -80 -126 -392 -621 -693 -1100 -855 -1358 -876 -1392 -971 -1542 -49 -79 -92 -143 -95 -143 -3 0 -37 51 -76 113 -778 1237 -1143 1818 -1675 2660 -131 208 -238 380 -238 382 0 3 117 5 260 5 l260 0 57 -90z m844 -32 c42 -68 136 -217 209 -333 73 -115 182 -290 244 -387 61 -98 113 -178 116 -178 3 0 23 31 46 68 23 37 123 198 224 357 100 160 225 359 278 443 l95 152 264 0 c209 0 263 -3 257 -12 -4 -7 -214 -341 -467 -743 -253 -401 -509 -809 -570 -905 -139 -222 -127 -207 -148 -173 -28 46 -627 997 -898 1427 -138 219 -251 400 -251 402 0 2 118 4 263 4 l262 0 76 -122z m787 -85 c-72 -115 -149 -238 -172 -275 -22 -38 -43 -68 -46 -68 -3 0 -33 44 -66 98 -34 53 -108 171 -166 262 -57 91 -107 171 -112 178 -6 9 66 12 343 12 l351 0 -132 -207z m-2100 -439 l202 -321 0 -2277 0 -2276 -210 0 -210 0 0 2607 c0 1434 4 2603 8 2598 5 -6 99 -154 210 -331z m3997 -4798 c11 -9 25 -16 30 -16 6 0 0 -6 -12 -13 -12 -7 -34 -29 -51 -49 -28 -36 -29 -36 -45 -17 -15 17 -31 19 -192 19 l-175 0 0 2269 0 2269 191 303 c105 167 198 315 207 329 16 23 17 -145 22 -2527 5 -2537 5 -2552 25 -2567z m-3326 3730 l201 -319 0 -1744 0 -1743 -210 0 -210 0 0 2072 c0 1260 4 2068 9 2063 5 -6 100 -154 210 -329z m2631 -1741 l0 -2065 -210 0 -210 0 0 1738 0 1737 207 328 c114 180 209 327 210 327 2 0 3 -929 3 -2065z m-1892 564 c144 -229 262 -419 262 -422 0 -4 -124 -7 -275 -7 l-275 0 0 437 c0 368 2 435 13 423 8 -8 132 -202 275 -431z m1230 9 l-3 -433 -272 -3 c-152 -1 -273 2 -273 6 0 5 118 195 261 423 144 227 264 419 266 426 19 49 23 -31 21 -419z m2 -903 l0 -205 -760 0 -760 0 0 205 0 205 760 0 760 0 0 -205z m-2 -677 l2 -208 -760 0 -760 0 0 210 0 210 758 -2 757 -3 3 -207z m2 -763 l0 -295 -760 0 -760 0 0 295 0 295 760 0 760 0 0 -295z" />
		</g>
	</svg>
);

export const EditIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="18 12 120 120"
		aria-label="Edit"
		role="img"
		focusable="false"
		{...rest}>
		<g
			transform="rotate(225 75 75)"
			stroke={color}
			strokeWidth="8"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none">
			<polygon points="75,20 55,50 95,50" />
			<polygon points="75,20 68.3,30 81.7,30" fill={color} stroke="none" />
			<rect x="55" y="50" width="40" height="70" />
			<line x1="75" y1="50" x2="75" y2="120" />
			<path d="M 55,120 C 55,145 95,145 95,120 Z" />
		</g>
	</svg>
);

export const PreviewIcon = ({ size = 20, color = 'currentColor', ...rest }) => {
	const maskId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="16 6 98 113"
			aria-label="Preview"
			role="img"
			focusable="false"
			{...rest}>
			<defs>
				<mask id={maskId}>
					<rect width="100%" height="100%" fill="white" />
					<circle cx="75" cy="80" r="22" fill="black" />
				</mask>
			</defs>
			<g
				mask={`url(#${maskId})`}
				fill="none"
				stroke={color}
				strokeWidth="8"
				strokeLinejoin="miter"
				strokeLinecap="butt">
				<polygon points="20,10 20,100 90,100 90,35 65,10" />
				<polyline points="65,10 65,35 90,35" />
				<line x1="35" y1="50" x2="75" y2="50" />
				<line x1="35" y1="65" x2="75" y2="65" />
				<line x1="35" y1="80" x2="75" y2="80" />
			</g>
			<g fill="none" stroke={color}>
				<circle cx="75" cy="80" r="18" strokeWidth="8" />
				<line x1="88" y1="93" x2="105" y2="110" strokeWidth="10" strokeLinecap="square" />
			</g>
		</svg>
	);
};

export const CloseIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="3"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="Remove"
		role="img"
		focusable="false"
		{...rest}>
		<line x1="5" y1="5" x2="19" y2="19" />
		<line x1="19" y1="5" x2="5" y2="19" />
	</svg>
);

export const CheckIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="3"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="Confirm"
		role="img"
		focusable="false"
		{...rest}>
		<polyline points="5,13 10,18 19,6" />
	</svg>
);

export const KebabIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill={color}
		aria-label="More actions"
		role="img"
		focusable="false"
		{...rest}>
		<circle cx="12" cy="5" r="2" />
		<circle cx="12" cy="12" r="2" />
		<circle cx="12" cy="19" r="2" />
	</svg>
);

export const EyeIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="View"
		role="img"
		focusable="false"
		{...rest}>
		<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
		<circle cx="12" cy="12" r="3" />
	</svg>
);

export const CheckCircleIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="Approve"
		role="img"
		focusable="false"
		{...rest}>
		<circle cx="12" cy="12" r="9" />
		<path d="M8 12.5l2.5 2.5L16 9.5" />
	</svg>
);

export const XCircleIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="Deny"
		role="img"
		focusable="false"
		{...rest}>
		<circle cx="12" cy="12" r="9" />
		<path d="M9.5 9.5l5 5M14.5 9.5l-5 5" />
	</svg>
);

export const BanIcon = ({ size = 20, color = 'currentColor', ...rest }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label="Cancel"
		role="img"
		focusable="false"
		{...rest}>
		<circle cx="12" cy="12" r="9" />
		<path d="M6.3 6.3l11.4 11.4" />
	</svg>
);

export const ErrorIcon = ({ size = 16, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill={color} />
		<line x1="12" y1="9" x2="12" y2="13" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
		<circle cx="12" cy="17" r="1" fill="#fff" />
	</svg>
);

export const NewMessageIcon = ({ count = 0, size = 32 }) => {
	const label = count > 10 ? "9+" : String(count);
	const width = Math.round((size * 36) / 32);
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={size}
			viewBox="0 0 36 32"
			overflow="visible"
			aria-label={`${count} new message`}
			role="img"
			focusable="false">
			{/* Envelope body */}
			<rect x="2" y="8" width="26" height="18" rx="2" ry="2" fill="#ac2431" />
			{/* Envelope flap */}
			<polyline
				points="2,8 15,19 28,8"
				fill="none"
				stroke="#fff"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			{/* Count badge */}
			<circle cx="27" cy="10" r="7" fill="#fff" stroke="#ac2431" strokeWidth="1" />
			<text
				x="27"
				y="10"
				textAnchor="middle"
				dominantBaseline="central"
				fill="#ac2431"
				fontSize="8"
				fontWeight="bold"
				fontFamily="sans-serif">
				{label}
			</text>
		</svg>
	);
};

// ─── Property Editor Tab Icons ────────────────────────────────────────────────

const PE_SVG = ({ size = 16, strokeWidth = 1.8, children, ...rest }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...rest}>
		{children}
	</svg>
);

export const MapPinIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M12 2a7 7 0 0 1 7 7c0 5-7 13-7 13S5 14 5 9a7 7 0 0 1 7-7z" />
		<circle cx="12" cy="9" r="2.5" />
	</PE_SVG>
);

export const BedIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M2 20v-3a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v3" />
		<path d="M2 17h20" />
		<path d="M2 10V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3" />
		<circle cx="8" cy="10" r="1.5" />
	</PE_SVG>
);

export const SparklesIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M12 3v2M12 19v2M3 12H1M23 12h-2M5.6 5.6 4.2 4.2M19.8 19.8l-1.4-1.4M5.6 18.4l-1.4 1.4M19.8 4.2l-1.4 1.4" />
		<circle cx="12" cy="12" r="4" />
	</PE_SVG>
);

export const CameraIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
		<circle cx="12" cy="13" r="4" />
	</PE_SVG>
);

export const TagIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
		<circle cx="7" cy="7" r="1.5" fill="currentColor" stroke="none" />
	</PE_SVG>
);

export const ClockIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<circle cx="12" cy="12" r="9" />
		<path d="M12 7v5l3 3" />
	</PE_SVG>
);

export const ShieldIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M12 2l8 3v7c0 4.5-3.5 8.5-8 10-4.5-1.5-8-5.5-8-10V5l8-3z" />
		<path d="M9 12l2 2 4-4" />
	</PE_SVG>
);

export const DocumentIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<path d="M14 2v6h6M8 13h8M8 17h5" />
	</PE_SVG>
);

export const BookOpenIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M2 3h9v18H2zM13 3h9v18h-9z" />
		<path d="M11 3v18" />
	</PE_SVG>
);

export const VRTourIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		{/* headset with a nose cutout along the bottom */}
		<path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h13A2.5 2.5 0 0 1 21 8.5v6a2.5 2.5 0 0 1-2.5 2.5h-3.2a2 2 0 0 1-1.6-.8l-1-1.3a.9.9 0 0 0-1.4 0l-1 1.3a2 2 0 0 1-1.6.8H5.5A2.5 2.5 0 0 1 3 14.5z" />
		{/* lenses */}
		<circle cx="8" cy="11.5" r="2" />
		<circle cx="16" cy="11.5" r="2" />
		{/* strap */}
		<path d="M3 11.5H1.5M21 11.5h1.5" />
	</PE_SVG>
);

export const ExternalLinkIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M14 4h6v6" />
		<path d="M20 4 11 13" />
		<path d="M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10" />
	</PE_SVG>
);

export const GuestbookIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		{/* book with spine and page edge */}
		<path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
		{/* house on the cover */}
		<path d="M9.5 10 13.25 6.75 17 10" />
		<path d="M10.75 9v4.25h5V9" />
	</PE_SVG>
);

export const PagesIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		{/* back page, peeking out behind the front one */}
		<path d="M16 6V3.5A1.5 1.5 0 0 0 14.5 2h-9A1.5 1.5 0 0 0 4 3.5v13A1.5 1.5 0 0 0 5.5 18H8" />
		{/* front page with folded corner */}
		<path d="M14 6H9.5A1.5 1.5 0 0 0 8 7.5v13A1.5 1.5 0 0 0 9.5 22h9a1.5 1.5 0 0 0 1.5-1.5V12z" />
		<path d="M14 6v6h6" />
		<path d="M11 15.5h6M11 18.5h4" />
	</PE_SVG>
);

export const StarIcon = ({
	size = 16,
	filled = false,
	color = "currentColor",
	...rest
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill={filled ? color : "none"}
		stroke={color}
		strokeWidth={filled ? 0 : 1.8}
		strokeLinecap="round"
		strokeLinejoin="round"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}>
		<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
	</svg>
);

export const MonitorIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<rect x="2" y="3" width="20" height="14" rx="2" />
		<path d="M8 21h8M12 17v4" />
	</PE_SVG>
);

export const ClipboardIcon = ({ size = 20 }) => (
	<PE_SVG size={size}>
		<rect x="5" y="4" width="14" height="17" rx="2" />
		<path d="M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z" />
		<path d="M8 11h8M8 14.5h8M8 18h5" />
	</PE_SVG>
);

export const RefreshIcon = ({ size = 20 }) => (
	<PE_SVG size={size}>
		<path d="M21 12a9 9 0 0 1-15.3 6.4M3 12a9 9 0 0 1 15.3-6.4" />
		<path d="M21 4v5h-5" />
		<path d="M3 20v-5h5" />
	</PE_SVG>
);

export const MailIcon = ({ size = 16, ...rest }) => (
	<PE_SVG size={size} {...rest}>
		<rect x="2" y="4" width="20" height="16" rx="2" />
		<path d="M2 6l10 7 10-7" />
	</PE_SVG>
);

export const SmsIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		<path d="M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9l-5 4v-4H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
	</PE_SVG>
);

export const PlusIcon = ({ size = 20 }) => (
	<PE_SVG size={size} strokeWidth={3}>
		<path d="M12 5v14M5 12h14" />
	</PE_SVG>
);

export const TrashIcon = ({ size = 20 }) => (
	<PE_SVG size={size}>
		<path d="M3 6h18" />
		<path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
		<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
		<path d="M10 11v6M14 11v6" />
	</PE_SVG>
);

export const HubIcon = ({ size = 16 }) => (
	<PE_SVG size={size}>
		{/* spokes */}
		<line x1="12" y1="12" x2="12" y2="3.5"  />
		<line x1="12" y1="12" x2="12" y2="20.5" />
		<line x1="12" y1="12" x2="3.5"  y2="12" />
		<line x1="12" y1="12" x2="20.5" y2="12" />
		<line x1="12" y1="12" x2="6"  y2="6"  />
		<line x1="12" y1="12" x2="18" y2="18" />
		<line x1="12" y1="12" x2="18" y2="6"  />
		<line x1="12" y1="12" x2="6"  y2="18" />
		{/* center node */}
		<circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
		{/* satellite nodes */}
		<circle cx="12" cy="2.5"  r="1.6" fill="currentColor" stroke="none" />
		<circle cx="12" cy="21.5" r="1.6" fill="currentColor" stroke="none" />
		<circle cx="2.5"  cy="12" r="1.6" fill="currentColor" stroke="none" />
		<circle cx="21.5" cy="12" r="1.6" fill="currentColor" stroke="none" />
		<circle cx="5.5"  cy="5.5"  r="1.6" fill="currentColor" stroke="none" />
		<circle cx="18.5" cy="18.5" r="1.6" fill="currentColor" stroke="none" />
		<circle cx="18.5" cy="5.5"  r="1.6" fill="currentColor" stroke="none" />
		<circle cx="5.5"  cy="18.5" r="1.6" fill="currentColor" stroke="none" />
	</PE_SVG>
);

// ─── Organization Editor Tab Icons ────────────────────────────────────────────

export const IntegrationIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<rect x="3" y="3" width="18" height="18" rx="3" />
		<path d="M12 3 L12 7 A1.5 1.5 0 0 1 12 10 L12 12 M21 12 L17 12 A1.5 1.5 0 0 1 14 12 L12 12 M12 21 L12 17 A1.5 1.5 0 0 1 12 14 L12 12 M3 12 L7 12 A1.5 1.5 0 0 1 10 12 L12 12" />
	</svg>
);

export const CalendarSettingsIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
	</svg>
);

export const CheckinIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
	</svg>
);

export const CommHubIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
	</svg>
);

export const LogoIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" />
	</svg>
);

export const SmartSiteIcon = ({ size = 16 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
	</svg>
);

export const IconAI = () => (
	<svg
		className="icon-svg-ai"
		width="40"
		height="20"
		viewBox="0 0 100 50"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="AI with soft rounded stars">
		{/*Large rounded 4-point star (left) */}
		<g transform="translate(0,0) scale(0.8)">
			<path
				d="M32 18 Q36 30 48 32 Q36 34 32 46 Q28 34 16 32 Q28 30 32 18Z"
				fill="#69c"
			/>
		</g>
		{/*Medium rounded 4-point star (above) */}
		<g transform="translate(28,4) scale(0.45)">
			<path
				d="M32 18 Q36 30 48 32 Q36 34 32 46 Q28 34 16 32 Q28 30 32 18Z"
				fill="#69c"
			/>
		</g>
		{/*Small rounded 4-point star (below left) */}
		<g transform="translate(24,0) scale(0.3)">
			<path
				d="M32 18 Q36 30 48 32 Q36 34 32 46 Q28 34 16 32 Q28 30 32 18Z"
				fill="#69c"
			/>
		</g>
		<text
			x="54"
			y="32"
			fontFamily="'Assistant', Arial, Helvetica, sans-serif"
			fontSize="24"
			fontWeight="bold"
			fill="#69c"
			letterSpacing="2">
			AI
		</text>
	</svg>
);

export const CriticalIcon = ({
	size = 16,
	className = "",
	title = "Critical priority",
	color = "currentColor",
	fg = "#fff",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M8 1.5 L15 14.5 H1 Z" fill={color} />
		<line
			x1="8"
			y1="6"
			x2="8"
			y2="10"
			stroke={fg}
			strokeWidth={weight}
			strokeLinecap="round"
		/>
		<circle cx="8" cy="12.25" r="1" fill={fg} />
	</svg>
);

export const TriangleIcon = ({
	size = 16,
	className = "",
	title = "High priority",
	color = "currentColor",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M8 1.5 L15 14.5 H1 Z" fill={color} />
	</svg>
);

export const CircleIcon = ({
	size = 16,
	className = "",
	title = "Medium priority",
	color = "currentColor",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="8" cy="8" r="6.5" fill={color} />
	</svg>
);

export const DownTriangleIcon = ({
	size = 16,
	className = "",
	title = "Low priority",
	color = "currentColor",
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		width={size}
		height={size}
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M8 14.5 L1 1.5 H15 Z" fill={color} />
	</svg>
);

export const ReplyIcon = ({
	size = 20,
	className = "",
	title = "Reply",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<polyline points="9 14 4 9 9 4" />
		<path d="M20 20v-7a4 4 0 0 0-4-4H4" />
	</svg>
);

export const FirstPageIcon = ({
	size = 20,
	className = "",
	title = "First page",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<line x1="6" y1="5" x2="6" y2="19" />
		<path d="M18 5 L8 12 L18 19 Z" strokeLinejoin="round" fill="none" />
	</svg>
);

export const OpenNewTabIcon = ({
	size = 20,
	className = "",
	title = "Open in new tab",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
		<polyline points="15 3 21 3 21 9" />
		<line x1="10" y1="14" x2="21" y2="3" />
	</svg>
);

export const LinkIcon = ({
	size = 20,
	className = "",
	title = "Copy link",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M9 17H7A5 5 0 0 1 7 7h2" />
		<path d="M15 7h2a5 5 0 1 1 0 10h-2" />
		<line x1="8" y1="12" x2="16" y2="12" />
	</svg>
);

export const InfoIcon = ({
	size = 16,
	className = "",
	title = "Info",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="12" cy="12" r="9" />
		<line x1="12" y1="11" x2="12" y2="16" />
		<circle cx="12" cy="7.5" r="0.9" fill="currentColor" stroke="none" />
	</svg>
);

export const QuestionMarkIcon = ({
	size = 16,
	className = "",
	title = "Help",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="12" cy="12" r="9" />
		<path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.7.35-1 .7-1 1.7" />
		<circle cx="12" cy="16.5" r="0.9" fill="currentColor" stroke="none" />
	</svg>
);

export const ExclamationMarkIcon = ({
	size = 16,
	className = "",
	title = "Important",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="12" cy="12" r="9" />
		<line x1="12" y1="7.5" x2="12" y2="13" />
		<circle cx="12" cy="16.5" r="0.9" fill="currentColor" stroke="none" />
	</svg>
);

export const CallIcon = ({
	size = 16,
	className = "",
	title = "Phone",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
	</svg>
);

export const CellPhoneIcon = ({
	size = 16,
	className = "",
	title = "Cell phone",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="7" y="2" width="10" height="20" rx="2" />
		<line x1="11" y1="18" x2="13" y2="18" />
	</svg>
);

export const CopyIcon = ({
	size = 16,
	className = "",
	title = "Copy",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="9" y="9" width="13" height="13" rx="2" />
		<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
	</svg>
);

export const BathIcon = ({
	size = 16,
	className = "",
	title = "Bathrooms",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M4 12h16a1 1 0 0 1 1 1v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5v-2a1 1 0 0 1 1-1z" />
		<path d="M4 12V6a2 2 0 0 1 2-2h1" />
		<line x1="9" y1="4" x2="9" y2="7" />
		<line x1="2" y1="20" x2="22" y2="20" />
	</svg>
);

export const EyeOffIcon = ({
	size = 20,
	className = "",
	title = "Hide",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
		<line x1="1" y1="1" x2="23" y2="23" />
	</svg>
);

export const CalendarCheckIcon = ({
	size = 16,
	className = "",
	title = "Available",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="3" y="4" width="18" height="18" rx="2" />
		<line x1="16" y1="2" x2="16" y2="6" />
		<line x1="8" y1="2" x2="8" y2="6" />
		<line x1="3" y1="10" x2="21" y2="10" />
		<path d="M9 15l2 2 4-4" />
	</svg>
);

export const CalendarCrossIcon = ({
	size = 16,
	className = "",
	title = "Blocked",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="3" y="4" width="18" height="18" rx="2" />
		<line x1="16" y1="2" x2="16" y2="6" />
		<line x1="8" y1="2" x2="8" y2="6" />
		<line x1="3" y1="10" x2="21" y2="10" />
		<line x1="9" y1="14" x2="15" y2="18" />
		<line x1="15" y1="14" x2="9" y2="18" />
	</svg>
);

export const MoveIcon = ({
	size = 20,
	className = "",
	title = "Move",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<polyline points="5 9 2 12 5 15" />
		<polyline points="9 5 12 2 15 5" />
		<polyline points="15 19 12 22 9 19" />
		<polyline points="19 9 22 12 19 15" />
		<line x1="2" y1="12" x2="22" y2="12" />
		<line x1="12" y1="2" x2="12" y2="22" />
	</svg>
);

export const CropIcon = ({
	size = 20,
	className = "",
	title = "Crop",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M6.13 1 6 16a2 2 0 0 0 2 2h15" />
		<path d="M1 6.13 16 6a2 2 0 0 1 2 2v15" />
	</svg>
);

export const ZoomInIcon = ({
	size = 20,
	className = "",
	title = "Zoom in",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="11" cy="11" r="8" />
		<line x1="21" y1="21" x2="16.65" y2="16.65" />
		<line x1="11" y1="8" x2="11" y2="14" />
		<line x1="8" y1="11" x2="14" y2="11" />
	</svg>
);

export const ZoomOutIcon = ({
	size = 20,
	className = "",
	title = "Zoom out",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="11" cy="11" r="8" />
		<line x1="21" y1="21" x2="16.65" y2="16.65" />
		<line x1="8" y1="11" x2="14" y2="11" />
	</svg>
);

export const RotateLeftIcon = ({
	size = 20,
	className = "",
	title = "Rotate left",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<polyline points="1 4 1 10 7 10" />
		<path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
	</svg>
);

export const RotateRightIcon = ({
	size = 20,
	className = "",
	title = "Rotate right",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<polyline points="23 4 23 10 17 10" />
		<path d="M20.49 15a9 9 0 1 1-2.13-9.36L23 10" />
	</svg>
);

export const SearchIcon = ({
	size = 16,
	className = "",
	title = "Search",
	weight = 2,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="11" cy="11" r="8" />
		<line x1="21" y1="21" x2="16.65" y2="16.65" />
	</svg>
);

export const CapsLockIcon = ({
	size = 16,
	className = "",
	title = "Caps lock is on",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M12 3 19 10 15 10 15 17 9 17 9 10 5 10Z" />
		<line x1="7" y1="20" x2="17" y2="20" />
	</svg>
);

export const ThermostatIcon = ({
	size = 16,
	className = "",
	title = "Thermostat",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" />
	</svg>
);

export const PieChartIcon = ({
	size = 16,
	className = "",
	title = "Pie chart",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
		<path d="M22 12A10 10 0 0 0 12 2v10z" />
	</svg>
);

export const PlayIcon = ({
	size = 16,
	className = "",
	title = "Play",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<circle cx="12" cy="12" r="10" />
		<polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none" />
	</svg>
);

export const FilterIcon = ({
	size = 16,
	className = "",
	title = "Filter",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
	</svg>
);

export const CalendarBoltIcon = ({
	size = 16,
	className = "",
	title = "Force booking",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="3" y="4" width="18" height="18" rx="2" />
		<line x1="16" y1="2" x2="16" y2="6" />
		<line x1="8" y1="2" x2="8" y2="6" />
		<line x1="3" y1="10" x2="21" y2="10" />
		<polygon
			points="12.4 11 8 17 11.6 17 11.1 21 16 15 12.4 15 12.4 11"
			fill="currentColor"
			stroke="none"
		/>
	</svg>
);

export const DoorIcon = ({
	size = 16,
	className = "",
	title = "Rooms",
	weight = 1.8,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size}
		height={size}
		fill="none"
		stroke="currentColor"
		strokeWidth={weight}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-label={title}
		role="img"
		focusable="false"
		className={className}
		{...rest}>
		<title>{title}</title>
		<rect x="5" y="2" width="14" height="20" rx="1" />
		<circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
	</svg>
);